import { el } from "../lib/dom";
import { getSettings, setSetting, resetProgress, getCloudStatus, getProgress } from "../lib/storage";
import { isFirebaseConfigured } from "../lib/firebase";
import { modal, toast } from "./components";
import { navigate } from "./router";
import type { Screen } from "./home";

function toggleRow(label: string, value: boolean, onChange: (v: boolean) => void): HTMLElement {
  const sw = el(`button.switch${value ? ".on" : ""}`, { role: "switch", "aria-checked": String(value) });
  sw.append(el("span.switch-knob"));
  sw.addEventListener("click", () => {
    const next = !sw.classList.contains("on");
    sw.classList.toggle("on", next);
    sw.setAttribute("aria-checked", String(next));
    onChange(next);
  });
  return el("div.settings-row", {}, el("span", {}, label), sw);
}

export function settingsScreen(): Screen {
  const s = getSettings();
  const cloud = getCloudStatus();
  const cloudText = !isFirebaseConfigured()
    ? "Lokaal (geen Firebase ingesteld) - voortgang blijft op dit toestel."
    : cloud === "synced"
      ? "Verbonden met de cloud. Voortgang wordt automatisch gesynchroniseerd."
      : cloud === "syncing"
        ? "Verbinden met de cloud..."
        : "Offline - wijzigingen worden later gesynchroniseerd.";

  const header = el(
    "header.app-header",
    {},
    el("button.icon-btn", { onclick: () => navigate("/"), "aria-label": "Terug" }, "‹"),
    el("div.level-header-title", {}, "Instellingen"),
    el("span", {}, ""),
  );

  const node = el(
    "div.screen.settings-screen",
    {},
    header,
    el(
      "div.settings-card",
      {},
      toggleRow("Geluid", s.sound, (v) => setSetting("sound", v)),
      toggleRow("Trillen (haptics)", s.haptics, (v) => setSetting("haptics", v)),
    ),
    el("div.settings-card", {}, el("div.settings-row", {}, el("span", {}, "Opslag"), el("span.cloud-pill", {}, getCloudStatus() === "synced" ? "Cloud" : "Lokaal"))),
    el("p.settings-note", {}, cloudText),
    el(
      "div.settings-card",
      {},
      el("div.settings-row", {}, el("span", {}, "Munten"), el("span", {}, `🪙 ${getProgress().coins}`)),
    ),
    el(
      "button.btn.danger",
      {
        onclick: () => {
          const close = modal({
            title: "Voortgang wissen?",
            body: "Al je levels en sterren worden verwijderd. Dit kan niet ongedaan worden gemaakt.",
            buttons: [
              { label: "Annuleren", onClick: () => close() },
              {
                label: "Wissen",
                primary: true,
                onClick: () => {
                  resetProgress();
                  close();
                  toast("Voortgang gewist");
                  navigate("/");
                },
              },
            ],
          });
        },
      },
      "Voortgang wissen",
    ),
    el("p.footer-note", {}, "Logika · gemaakt met ❤️ voor onderweg"),
  );

  return { node };
}
